/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Camera_BusyInputs */

const vi_qr_camera_busy = /** @type {(inputs: Qr_Camera_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera đang được ứng dụng hoặc tab khác dùng. Tắt ứng dụng đó rồi bấm mở camera lại, hoặc nhập tay bên dưới.`)
};

/**

* @param {Qr_Camera_BusyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_camera_busy = /** @type {((inputs?: Qr_Camera_BusyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Camera_BusyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_camera_busy(inputs)
});